import Spacer from "../../../../../components/Content/Spacer";
import Typography from "../../../../../components/Typography";
import { ScheduleInfoContainer } from "./styled";

export default function ScheduleInfo({ description, subcontent }) {
  return (
    <ScheduleInfoContainer>
      <Spacer size="spacing_m" />
      <Typography textAlign="center" fontSize="1.3rem" margin={[0]}>
        {description}
      </Typography>
      <br />
      <Typography
        textAlign="center"
        color="darkGray2"
        fontSize="1.5rem"
        fontWeight="bold"
      >
        Schedule your FREE in-home consultation today!
      </Typography>
      {subcontent && (
        <Typography
          textAlign="center"
          color="darkGray2"
          fontSize="1rem"

        >
          <i>{subcontent}</i>
        </Typography>)}

    </ScheduleInfoContainer>
  );
}
